import { Link } from "react-router-dom";
import "../CSS/ReMocard.css";
import DateConvert from "../Utlis/DateConverter";

function ReMoCard({ blogPosts, error, loading, title }) {
  return (
    <div className="remoWrap" key={Math.random}>
      <h2>{title}</h2>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>Error fetching data: {error.message}</p>
      ) : (
        <div>
          {blogPosts.map((post) => (
            <Link to={`/BlogPage/${post._id}`} className="Remocardlink" key={post._id}>
              <div className="RelatedNewsCard" key={post._id}>
                <h6 className="remoTitle">{post.title}</h6>
                <p className="remoDetails">
                  {post.author} | {DateConvert(post.createdAt)} | {post.Sector}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReMoCard;
